/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ServerLengthModelVariant = {
    DetectorSegmentator: 'DETECTOR_SEGMENTATOR',
    SegmentatorOnly: 'SEGMENTATOR_ONLY',
} as const;
export type ServerLengthModelVariant = typeof ServerLengthModelVariant[keyof typeof ServerLengthModelVariant];


export function instanceOfServerLengthModelVariant(value: any): boolean {
    for (const key in ServerLengthModelVariant) {
        if (Object.prototype.hasOwnProperty.call(ServerLengthModelVariant, key)) {
            if (ServerLengthModelVariant[key as keyof typeof ServerLengthModelVariant] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ServerLengthModelVariantFromJSON(json: any): ServerLengthModelVariant {
    return ServerLengthModelVariantFromJSONTyped(json, false);
}

export function ServerLengthModelVariantFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServerLengthModelVariant {
    return json as ServerLengthModelVariant;
}

export function ServerLengthModelVariantToJSON(value?: ServerLengthModelVariant | null): any {
    return value as any;
}

export function ServerLengthModelVariantToJSONTyped(value: any, ignoreDiscriminator: boolean): ServerLengthModelVariant {
    return value as ServerLengthModelVariant;
}

